<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-polygon`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.182 17.678L26.464 5.388a4 4 0 00-4.928 0L5.818 17.678a4 4 0 00-1.322 4.442l5.981 17.542a4 4 0 003.786 2.71h19.474a4 4 0 003.786-2.71l5.981-17.542a4 4 0 00-1.322-4.442zm-33.9 3.15L24 8.539l15.718 12.29-5.981 17.543H14.263L8.282 20.83z"/></svg>
</template>
<script>

export default {
  name: 'IconPolygon',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
